import { IconButtonProps, IconButtonSize } from '@xemplo/icon-button';
import { DawnCross } from '@xemplo/icons';

import * as S from './prompt-close-button.styles';

export function PromptCloseButton(props: Readonly<IconButtonProps>) {
  return (
    <S.CloseButton naked size={IconButtonSize.Small} {...props}>
      <DawnCross fontSize={16} />
    </S.CloseButton>
  );
}
